import * as React from 'react'

import { Box, Button, Section, Skeleton, Tag, Text } from '@factorialco/deprecated-design-system'
import { range, sample } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { useTags } from 'modules/ats/hooks/tags/useTags'

import { TagsContainer } from './TagsContainer'
import { TagsSidepanel } from './TagsSidepanel'

interface Props {
  maxTagsToShow?: number
}

export const TagManager = ({ maxTagsToShow = 15 }: Props) => {
  const { loading, tags } = useTags()
  const [open, setOpen] = React.useState(false)
  const remaining = tags.slice(maxTagsToShow).length
  const tagsToShow = tags.slice(0, maxTagsToShow)
  const boxAlignment = tags.length ? 'flexStart' : 'center'

  const onEditClick = () => {
    setOpen(true)
  }

  return (
    <Section
      illustration="user-bookmark"
      title={i18n.t('ats.tags.manager.title')}
      description={i18n.t('ats.tags.manager.description')}
      link={{
        label: i18n.t('common.learn_more'),
        href: i18n.t('ats.tags.manager.help_center_url'),
      }}
    >
      <Box>
        <TagsContainer
          boxAlignment={boxAlignment}
          action={
            <Button type="secondary" onClick={onEditClick} disabled={loading} iconName="pencil">
              {i18n.t('ats.tags.manager.manage')}
            </Button>
          }
        >
          {loading &&
            range(15).map((n) => (
              <Skeleton key={n} width={sample(['s48', 's64', 's80', 's96'])} height="s24" />
            ))}

          {!tags.length && !loading && (
            <Text.Normal>{i18n.t('ats.tags.manager.empty_state')}</Text.Normal>
          )}

          {tagsToShow.map((tag) => (
            <Tag key={tag.name} inline>
              {tag.name}
            </Tag>
          ))}

          {remaining > 0 && (
            <Text.Normal>{i18n.t('ats.tags.manager.remaining', { count: remaining })}</Text.Normal>
          )}
          <TagsSidepanel open={open} onClose={() => setOpen(false)} tags={tags} />
        </TagsContainer>
      </Box>
    </Section>
  )
}
